<template>
    <div class="row">
        <div class="col-12 col-lg-12" v-if="renderItems.length >= itemsPerPage">
            <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
                <slot-component v-for="(item, index) in renderItems" :key="index" :vnode="item" />
            </div>
        </div>

        <div :class="columnWidths" v-else v-for="item in renderItems">
            <slot-component :vnode="item"/>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },

    props: {
        itemsPerPage: {
            type: Number,
            default: 4
        }
    },

    computed:
    {
        renderItems()
        {
            return (this.$slots.items || []).filter(vnode => vnode && (vnode.tag || vnode.componentOptions));
        },

        columnWidths()
        {
            const itemsPerPage = Math.min(Math.max(this.itemsPerPage, 1), 4);

            return [
                "col-12",
                itemsPerPage === 1 ? "col-sm-12" : "col-sm-6",
                "col-md-" + (12 / itemsPerPage)
            ];
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    updated()
    {
        this.initializeCarousel();
    },

    methods:
    {
        initializeCarousel()
        {
            if (this.renderItems.length >= this.itemsPerPage)
            {
                const $owl = $(this.$refs.carouselContainer);

                // do not render, if no html element is inside of the carousels container
                if (!$owl.children().length)
                {
                    return;
                }

                $owl.owlCarousel({
                    onInitialized(){
                        $owl.find(".owl-carousel.owl-loaded").each(function() {
                            $(this).trigger("refresh.owl.carousel");
                        });
                    },
                    autoHeight: true,
                    dots: true,
                    items: this.itemsPerPage,
                    responsive: {
                        0: {
                          items: 2
                        },
                        576: {
                          items: 2
                        },
                        768: {
                          items: 3
                        },
                        992: {
                          items: 3
                        },
                        1199: {
                          items: this.itemsPerPage
                      },
                    },
                    lazyLoad: false,
                    loop: false,
                    margin: 25,
                    mouseDrag: true,
                    nav: true,
                    navClass: [
                        "slide-phywe left",
                        "slide-phywe right"
                    ],
                    navContainerClass: "",
                    navText: [
                        "<i class=\"owl-single-item-control fa fa-caret-left\" aria-hidden=\"true\"></i>",
                        "<i class=\"owl-single-item-control fa fa-caret-right\" aria-hidden=\"true\"></i>"
                    ],
                    smartSpeed: 350
                });
            }
        }
    }
}
</script>
